import { FC } from 'react'
import {
    FooterArea,
    LayoutWrapper,
    ScrollableContent,
} from './IssueDrawerLayout.styles'
import { IssueDrawerLayoutProps } from './IssueDrawerLayout.types'

const IssueDrawerLayout: FC<IssueDrawerLayoutProps> = ({
    children,
    footer,
}) => (
    <LayoutWrapper
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
    >
        <ScrollableContent data-testid="issue-drawer-content">
            {children}
        </ScrollableContent>
        {footer && (
            <FooterArea data-testid="issue-drawer-footer">{footer}</FooterArea>
        )}
    </LayoutWrapper>
)

export default IssueDrawerLayout
